import { loc } from "../i18n/survey";

const durationQuestion = {
  type: 'radiogroup',
  name: 'duration',
  title: loc("quiz.duration.title"),
  description: loc("quiz.shared.startingPoint"),
  choices: ["0-6 months", "6-12 months", "1-3 years", "3+ years"].map((value) => ({
    value,
    text: loc(`quiz.duration.choices.${value}`),
  })),
  isRequired: true,
}

export {
  durationQuestion,
}